import React from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import StoreSummary from './index';
import { tradeSiteEnabled } from '../../utils/toggles';
import { check as anyUserLoggedIn } from '../../utils/tokenUtils';

const StoreSummaryRegistration = (props) => {
  const shouldRender = tradeSiteEnabled()
    ? anyUserLoggedIn()
    : props.registration.pending;

  if (!shouldRender) return <Redirect to="/registration/outlet"/>;

  return <StoreSummary isOnRegistrationPage {...props}/>;
};

const mapStateToProps = state => ({
  registration: state.registration,
});

export default connect(mapStateToProps)(StoreSummaryRegistration);



// WEBPACK FOOTER //
// ./src/components/store-summary/index-registration.jsx